// Darstellung wie auf der Live-Seite: „11.09.2026 – 12.09.2026" und
// „09:00 – 14:00 Uhr / 10:00 – 15:00 Uhr" (Zeiten hängen am Tag, Spec 4.2).
const GERMAN_DATE = (isoDate) => {
    const [year, month, day] = String(isoDate).split('-')
    return `${day}.${month}.${year}`
}

export const formatDayRange = (days = []) => {
    if (!days || 0 === days.length) return ''
    const first = GERMAN_DATE(days[0].date)
    const last = GERMAN_DATE(days[days.length - 1].date)
    return first === last ? first : `${first} – ${last}`
}

export const formatOpeningTimes = (days = []) => (days || [])
    .filter(day => day.openFrom && day.openUntil)
    .map(day => `${day.openFrom} – ${day.openUntil} Uhr`)
    .join(' / ')

// Kachel-Darstellung der Übersicht: „18“ groß, daneben „Sep 2026 · 08:00 – 14:00 Uhr“.
const MONTHS = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']

export const splitDay = (day) => {
    const [year, month, dayNumber] = String(day.date).split('-')
    return {
        dayNumber,
        monthYear: `${MONTHS[Number(month) - 1]} ${year}`,
        time: day.openFrom && day.openUntil ? `${day.openFrom} – ${day.openUntil} Uhr` : ''
    }
}
